var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71504 5.5571L7.715 5.55704C7.61618 5.43408 7.61602 5.25678 7.71509 5.13436M7.71504 5.5571L7.75396 5.16581M7.71504 5.5571L9.96632 8.35059H2.74421C2.5355 8.35059 2.35954 8.1674 2.35954 7.93585L2.36023 2.75494V2.75493C2.36023 2.52335 2.53621 2.34019 2.7449 2.34019H9.96701M7.71504 5.5571L10.0073 2.29019M7.71509 5.13436L7.75396 5.16581M7.71509 5.13436L7.71503 5.13443L7.75396 5.16581M7.71509 5.13436L9.96701 2.34019M7.75396 5.16581L10.0312 2.34019H9.96701M9.96701 2.34019L10.0073 2.29019M10.0073 2.29019H10.0715H10.0073ZM11.943 2.02578L11.9433 2.02603L11.9466 2.02072C12.0124 1.91441 12.05 1.78204 12.05 1.6477C12.05 1.31673 11.8038 0.95 11.3949 0.95H1.70583C1.56542 0.95 1.43632 0.998146 1.33075 1.07759C1.10809 1.16458 0.95 1.38898 0.95 1.6536V14.4342C0.95 14.7706 1.2059 15.05 1.5292 15.05C1.85172 15.05 2.1084 14.7714 2.1084 14.4342V9.74144H11.3949C11.8038 9.74144 12.05 9.37473 12.05 9.04374C12.05 8.90894 12.0122 8.77653 11.9395 8.66085L11.9398 8.66067L11.9361 8.65606L9.4868 5.61747C9.4868 5.61747 9.4868 5.61746 9.48679 5.61746C9.36011 5.4602 9.36011 5.23109 9.4868 5.07383L11.943 2.02578Z",
    fill: "#3B3B4A",
    stroke: "#3B3B4A",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.97a6a3f1.svg";
export { ForwardRef as ReactComponent };